// @flow
import type { AuthAction, AuthState } from './auth.types';

/*** Framework ***/
// TODO: Get form from API call?
import ForgetPassConfig from './configs/ForgetPassConfig';
import LoginConfig from './configs/LoginConfig';

/*** Form Enum ***/
export const Forms = {
  LOGIN: '/login',
  RESET_PASSWORD: '/forget-password'
};

/*** Selectors ***/
export const getFields = (state) => state.auth.form.fields;

/*** Actions ***/
export const LOCATION_CHANGE: string = '@@router/LOCATION_CHANGE';
export const FORM_COMPLETE: string = 'auth/FORM_COMPLETE';

/*** Action Creators ***/
export const formComplete = () => ({
  type: FORM_COMPLETE
});

/*** Reducer ***/
export const DEFAULT_STATE: AuthState = {
  activeTab: 'Log In',
  form: LoginConfig,
  complete: false
};

export default function AuthReducer(
  state: AuthState = DEFAULT_STATE,
  { payload, type }: AuthAction = {}
): AuthState {
  switch (type) {
    case LOCATION_CHANGE: {
      //TODO: flatten this
      const baseState: AuthState = {
        ...state,
        complete: false,
        form: null
      };
      switch (payload.pathname) {
        case Forms.LOGIN:
          return {
            ...baseState,
            complete: false,
            form: LoginConfig
          };
        case Forms.RESET_PASSWORD:
          return {
            ...baseState,
            complete: false,
            form: ForgetPassConfig
          };
        default:
          return state;
      }
    }
    case FORM_COMPLETE:
      return {
        ...state,
        complete: true
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/actions/auth/auth.js